import React from 'react';

// const SvgContainer = styled.svg`
//   width: 1.65em;
//   height: 1.65em;
//   padding-top: 9px;
//   .cls-1 {
//     fill: none;
//     stroke-linejoin: round;
//     stroke-width: 2px;
//   }
// `

const CalendarUnderline = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="32"
			height="32"
			fill="none"
			viewBox="0 0 32 32"
		>
			<path
				fill="#2d2d2d"
				d="M25 4h-1v2h1c.55 0 1 .45 1 1v1H7v2h19v14H6V7c0-.55.45-1 1-1h4V2H9v2H7C5.35 4 4 5.35 4 7v18c0 .55.45 1 1 1h22c.55 0 1-.45 1-1V7c0-1.65-1.35-3-3-3z"
			></path>
			<path
				fill="#2d2d2d"
				d="M22 6h1V2h-2v2h-9v2h10zM11 12H9v2h2v-2zM15 12h-2v2h2v-2zM19 12h-2v2h2v-2zM23 12h-2v2h2v-2zM11 16H9v2h2v-2zM15 16h-2v2h2v-2zM19 16h-2v2h2v-2zM23 16h-2v2h2v-2zM11 20H9v2h2v-2zM15 20h-2v2h2v-2zM19 20h-2v2h2v-2zM27 30H5v2h22v-2z"
			></path>
		</svg>
	);
};

export default CalendarUnderline;
